export class CompareService {
    public static COMPARE_STORAGE_ID = 'cp';
  
    public addProductToCompare(productId: number): number[] {
      if(window?.localStorage){
        const currentCompareProductIds = this.getCompareProductIds();
        if (!currentCompareProductIds.includes(productId)) {
          currentCompareProductIds.push(productId);
          window.localStorage?.setItem(
            CompareService.COMPARE_STORAGE_ID,
            currentCompareProductIds.join(','),
          );
        }
        return currentCompareProductIds;
      }

      return [];
    }
  
    public removeProductToCompare(productId: number): number[] {
      if(window?.localStorage){
        const currentCompareProductIds = this.getCompareProductIds();
        if (currentCompareProductIds.includes(productId)) {
          const leftCompareProductIds = currentCompareProductIds.filter(
            item => item !== productId,
          );
          window.localStorage?.setItem(
            CompareService.COMPARE_STORAGE_ID,
            leftCompareProductIds.join(','),
          );
          return leftCompareProductIds;
        }
        return currentCompareProductIds; 
      }

      return [];
    }
  
    public getCompareProductIds(): number[] {
      if(window?.localStorage){
        const compareStorageValue = window.localStorage?.getItem(
          CompareService.COMPARE_STORAGE_ID,
        );
        if (!compareStorageValue) {
          return [];
        }
    
        const productIds = compareStorageValue
          .split(',')
          .map(productId => parseInt(productId))
          .filter(item => !Number.isNaN(item));
        return productIds;
      }

      return [];
    }
  
    public getCompareProductCount(): number {
      const productIds = this.getCompareProductIds();
      return productIds.length;
    }
  
    public isProductInCompare(productId: number): boolean {
      const productIds = this.getCompareProductIds();
      return productIds.includes(productId);
    }
  
    public removeAll() {
      if(window?.localStorage){
        window.localStorage?.removeItem(CompareService.COMPARE_STORAGE_ID);
      }
    }
  
    public replaceCompareProducts(newProductsIds: (number | string)[]) {
      this.removeAll();
      for (const newProductId of newProductsIds) {
        try {
          let intProductId: number;
          if (typeof newProductId === 'string') {
            intProductId = parseInt(newProductId, 10);
          } else {
            intProductId = newProductId;
          }
  
          this.addProductToCompare(intProductId);
        } catch {}
      }
    }
  }
  